/**
 * SigningModeBadge — shared chip that surfaces how a contract leaves the
 * app: signed via Scrive, distributed manually (post), or just exported
 * with no signing. Reads the template's `metadata.signingMode`
 * ('scrive' | 'manual_delivery' | 'export_only', default 'scrive').
 *
 * Single component, multiple call sites (editor StatusBar, SigningPanel
 * header). ConnectedContractsPanel keeps an inline copy for now and can
 * later dedupe onto this.
 */

export type SigningMode = 'scrive' | 'manual_delivery' | 'export_only';

const VARIANTS: Record<
  SigningMode,
  { label: string; cls: string; title: string }
> = {
  scrive: {
    label: 'Scrive',
    cls: 'bg-stone-100 text-stone-600',
    title: 'Signeras via Scrive.',
  },
  manual_delivery: {
    label: 'Post',
    cls: 'bg-amber-100 text-amber-900',
    title: 'Signeras av en part och skickas separat (inte Scrive).',
  },
  export_only: {
    label: 'Endast PDF',
    cls: 'bg-sky-100 text-sky-900',
    title: 'Signeras inte — exporteras och skickas (t.ex. med rekommenderad post).',
  },
};

export function SigningModeBadge({
  signingMode = 'scrive',
  className,
}: {
  signingMode?: SigningMode;
  className?: string;
}) {
  const v = VARIANTS[signingMode] ?? VARIANTS.scrive;
  return (
    <span
      className={
        'shrink-0 rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wider ' +
        v.cls +
        (className ? ` ${className}` : '')
      }
      title={v.title}
    >
      {v.label}
    </span>
  );
}
